import React, { useState } from 'react';
import { Archive } from 'lucide-react';
import Modal from './Modal';

export default function ArchiveModal({ sessionId, onArchive, onClose }) {
  const [title, setTitle] = useState('');
  const submit = () => {
    onArchive(title);
    onClose();
  };

  return (
    <Modal title="Archive to your library" onClose={onClose}>
      <p className="text-body text-ink-2 mb-4">
        Saves a snapshot of this session, grid, votes, case stages, and timeline, to your
        private library, where you can review it or reuse it as a template for a future class.
      </p>
      <label className="text-meta font-medium text-ink-2 mb-1.5 block" htmlFor="archiveTitle">Title</label>
      <input
        id="archiveTitle"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        onKeyDown={(e) => e.key === 'Enter' && submit()}
        placeholder={`e.g. "Week 4: Chest pain (${sessionId})"`}
        autoFocus
        className="w-full px-3 py-2.5 border border-line rounded-ctl text-body outline-none focus:ring-2 focus:border-accent focus:ring-accent/25"
      />
      <div className="flex justify-end gap-2 mt-5">
        <button onClick={onClose} className="px-4 py-2 text-body text-ink-2 hover:bg-accent-tint rounded-ctl transition">Cancel</button>
        <button
          onClick={submit}
          className="flex items-center gap-1.5 bg-accent text-white px-4 py-2 rounded-ctl text-body font-medium hover:bg-accent-strong transition"
        >
          <Archive className="w-4 h-4" />Archive session
        </button>
      </div>
    </Modal>
  );
}
